import { QuestionTypes, SectionType, QuestionType } from "actions/questionActions";
import { Answer, ApiAnswer, getAnswerKey, UploadedAttachmentType } from "context/reportUserNotesAnswers";
import { dateFormatter } from "lib/commonFunctions";
import questions from "data/questions.json";

type Translate = (translationId: string, prefix?: string) => string;

export const apiAnswersToAnswersMap = (
  apiAnswers: Array<ApiAnswer>,
  translate: Translate
): Map<string, Answer> => {
  const newAnswersMap = new Map<string, Answer>();

  apiAnswers.forEach((apiAnswer: ApiAnswer) => {
    const answer = {
      ...apiAnswer,
      answerKey: getAnswerKey(apiAnswer.sectionKey, apiAnswer.questionKey),
      value: JSON.parse(apiAnswer.value),
    };
    newAnswersMap.set(answer.answerKey, answer);
  });

  if (questions) {
    questions.sections.forEach((section: SectionType) => {
      section.questions.forEach((question: QuestionType) => {
        const apiAnswer = newAnswersMap.get(getAnswerKey(section.key, question.key));

        if (apiAnswer) {
          if (question.type === QuestionTypes.DateTimeRange && Array.isArray(apiAnswer.value.answer)) {
            apiAnswer.valueFormatted =
              apiAnswer.value.answer.length === 1
                ? dateFormatter(apiAnswer.value.answer[0])
                : `${dateFormatter(apiAnswer.value.answer[0])} - ${dateFormatter(apiAnswer.value.answer[1])}`;
          } else if (question.type === QuestionTypes.MultiChoice) {
            apiAnswer.valueFormatted = translate(apiAnswer.value.answer[0]);
          } else if (question.type === QuestionTypes.Attachments) {
            apiAnswer.value.answer = apiAnswer.value.answer.filter((attachment: UploadedAttachmentType) => {
              return Object.keys(attachment).length !== 0;
            });
            const attachmentArray: [] = apiAnswer.value.answer.map((attachment: UploadedAttachmentType) => {
              return attachment.filename.toString();
            });
            apiAnswer.valueFormatted = attachmentArray.join(",");
          } else if (typeof apiAnswer.value.answer === "string") {
            apiAnswer.valueFormatted = translate(apiAnswer.value.answer);
          } else {
            if (apiAnswer.value.answer) {
              apiAnswer.valueFormatted = apiAnswer.value.answer.toString();
            }
          }

          apiAnswer.valueFormatted = apiAnswer.value.scale
            ? `${apiAnswer.valueFormatted} ${apiAnswer.value.scale}`
            : apiAnswer.valueFormatted;
          newAnswersMap.set(apiAnswer.answerKey, apiAnswer);
        }
      });
    });
  }

  return newAnswersMap;
};
